<div class="license-locked-page">
  <div class="license-locked-card">
    <div class="header">
      <div class="lock-icon" aria-hidden="true">🔒</div>
      <h1>{{ heading }}</h1>
      <p class="explanation">{{ explanation }}</p>
    </div>

    <div class="actions">
      <button
        *ngIf="isTransient"
        type="button"
        class="btn-primary"
        (click)="tryAgain()">
        Try again
      </button>
      <p *ngIf="!isTransient && supportEmail" class="support">
        Need help? Contact
        <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
      </p>
    </div>
  </div>
</div>
